module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-76x76-f2873e11afec5a35ace3620f65c62bb4.png";